// extracted by mini-css-extract-plugin
export default {"close-button":"CloseButton_close-button__0Jxuk"};